import * as React from "react";
import {LineChart, Line, CartesianGrid, XAxis, YAxis, Tooltip, ResponsiveContainer} from "recharts";

export interface SimpleTimeSeriesProps {
    data: Array<{ name: string; value: number }>;
    loading: boolean;
}

export function TimedLineChart(props: React.PropsWithChildren<SimpleTimeSeriesProps>) {
    if (props.loading) {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <h1>Loading...</h1>
            </div>
        );
    }

    if (props.data.length === 0) {
        return (
            <div style={{width: "100%", height: "100%"}}>
                <p>No data available for the selected filters.</p>
            </div>
        );
    }

    return (
        <div style={{width: "100%", height: 400}}>
            <ResponsiveContainer width="100%" height="100%">
                <LineChart data={props.data}>
                    <CartesianGrid stroke="#ccc"/>
                    <XAxis dataKey="name"/>
                    <YAxis allowDecimals={false}/>
                    <Tooltip/>
                    <Line type="monotone" dataKey="value" stroke="#82ca9d" strokeWidth={2} dot={{r: 3}}/>
                </LineChart>
            </ResponsiveContainer>
        </div>
    );
}


